"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("../../classnames"));
var Hamburger = function (_a) {
    var className = _a.className, _b = _a.open, open = _b === void 0 ? false : _b, onToggle = _a.onToggle;
    return (react_1.default.createElement("button", { type: "button", className: classnames_1.default("chq-ham", className, { "chq-ham-op": open }), onClick: onToggle, "aria-label": "Menu Toggle" },
        react_1.default.createElement("span", null),
        react_1.default.createElement("span", null),
        react_1.default.createElement("span", null)));
};
exports.default = Hamburger;
